import { render, staticRenderFns } from "./MainPopup_new.vue?vue&type=template&id=3ebfedb5&scoped=true"
import script from "./MainPopup_new.vue?vue&type=script&lang=js"
export * from "./MainPopup_new.vue?vue&type=script&lang=js"
import style0 from "./MainPopup_new.vue?vue&type=style&index=0&id=3ebfedb5&prod&scoped=true&lang=css"
import style1 from "./MainPopup_new.vue?vue&type=style&index=1&id=3ebfedb5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebfedb5",
  null
  
)

export default component.exports